import { Grid, Paper } from "@material-ui/core";
import CustomInput from "components/CustomInput";
import EmptyPlaceholder from "components/EmptyPlaceholder/EmptyPlaceholder";
import { TabsWrapper } from "components/TabsWrapper/TabsWrapper";
import { useGetClientsQuery } from "features/clients/clientSlice";
import { selectIsClient, selectUserClientId } from "features/user/userSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomReport from "../CustomReport";
import FormBuilder from "../formBuilder";
import { formTypeOptions, formTypes } from "../formBuilder/formBuilderConsts";
import { setActivityItemId, setClientId, setFormType } from "./formStateSlice";
import { FormListStyle } from "./style";
import ActivityTypesField from "features/activity/ActivityTypesField";

const FormList = ({ }) => {
    const classes = FormListStyle();
    const isClient = useSelector(selectIsClient);
    const currentClientId = useSelector(selectUserClientId);
    const { clientId, formType, activityItemId } = useSelector(state => state.formState);
    const location = useLocation();

    const dispatch = useDispatch()

    const searchParams = new URLSearchParams(location.search);
    const urlFormType = Number(searchParams.get('formType'));
    const urlActivityItemId = Number(searchParams.get('activityItemId'));
    const fromActivityPage =
        location.pathname.includes('/activity') &&
        (formType == formTypes.Activity || urlFormType === formTypes.Activity) &&
       (activityItemId ?? urlActivityItemId);

    let { data: clients, error: clientError, isLoading: isLoadingClients } = useGetClientsQuery(null, { skip: isClient });

    useEffect(() => {
        if (urlFormType) {
            dispatch(setFormType(urlFormType));
        }
        if (urlActivityItemId) {
            dispatch(setActivityItemId(urlActivityItemId));
        }
    }, [urlFormType, urlActivityItemId, dispatch]);

    useEffect(() => {
        if (isClient) {
            dispatch(setClientId(currentClientId ? currentClientId[0] : null));
        }
    }, [currentClientId, dispatch, isClient])

    const tabs = [
        {
            label: 'Form',
            component: <FormBuilder />
        },
        {
            label: 'Custom Report',
            component: <CustomReport />
        }
    ]

    return (
        <Grid container direction="column">
            <Paper className={classes.formListFilters}>
                {fromActivityPage &&
                    <h3>{`Custom Form for `}
                        <ActivityTypesField
                            value={activityItemId}
                            readonly
                        />
                        {` Activity`}
                    </h3>}
                <Grid container spacing={2}>
                    {!isClient && <Grid item xs={formType == formTypes.Activity ? 4 : 6} container direction="column" >
                        <Grid item className={classes.filterLabel}>Select Client</Grid>
                        <Grid item >
                            <CustomInput
                                id="clientId"
                                value={clientId}
                                elementType="dropdown"
                                onChange={val => {
                                    dispatch(setClientId(+val));
                                }}
                                values={clients}
                                showEmpty
                                placeholder={'Select client'}
                            />
                        </Grid>
                    </Grid>}
                    {!fromActivityPage &&
                        <Grid item xs={formType == formTypes.Activity ? 4 : 6} container direction="column">
                            <Grid item className={classes.filterLabel}>Select Form Type</Grid>
                            <Grid item >
                                <CustomInput
                                    id="formType"
                                    value={formType}
                                    elementType="dropdown"
                                    onChange={val => {
                                        dispatch(setFormType(+val));
                                        dispatch(setActivityItemId(null));
                                    }}
                                    values={formTypeOptions}
                                    showEmpty
                                    placeholder={'Select form type'}
                                />
                            </Grid>
                        </Grid>}
                    {formType == formTypes.Activity && !fromActivityPage &&
                        <Grid item xs={4} container direction="column">
                            <Grid item className={classes.filterLabel}>Activity Item</Grid>
                            <Grid item >
                                <ActivityTypesField
                                    value={activityItemId}
                                    onChange={val => {
                                        dispatch(setActivityItemId(+val))
                                    }}
                                    required={false}
                                    label=""
                                />
                            </Grid>
                        </Grid>}
                </Grid>
            </Paper>
            <div className={classes.formBuilderContainer}>
                {(!clientId || !formType || (formType == formTypes.Activity && !activityItemId)) && <EmptyPlaceholder
                    text="Please select client and form type"
                />}
                {!!clientId && !!formType && (formType != formTypes.Activity || !!activityItemId) && <>
                    {/* {Object.values(formTypes).map(formType =>
                    <div>
                        {formType}
                        {formByTypeMap?.[formType]?.name}
                    </div>)} */}
                    {/* < TabsWrapper tabs={tabs} /> */}
                    <FormBuilder />
                </>}
            </div>
        </Grid >
    )
}
export default FormList;